import { Flex, Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { formatMoney } from "infra/helpers/number";
import {
  OrcamentoCotacaoFornecedor,
  OrcamentoCotacaoItem,
} from "features/orcamento/typings";

interface ContentRightProps {
  item: OrcamentoCotacaoFornecedor;
}

export default function ContentRight({ item }: ContentRightProps) {
  const { items: itemsCotacao } = item;

  const reduceSum = (items: OrcamentoCotacaoItem[]) => {
    return items.reduce(
      (acc, item) => acc + (item.valorUnitario ?? 0) * (item.quantidade ?? 0),
      0
    );
  };

  const totalAprovado = reduceSum(
    itemsCotacao?.filter((item) => !!item.aprovadoEm)
  );

  const totalNaoAprovado = reduceSum(
    itemsCotacao?.filter((item) => !item.aprovadoEm)
  );

  return (
    <Flex w="100%" pr={4} flexDirection="column">
      <Flex mb={4} w="100%">
        <Flex
          flex={4}
          h="20px"
          w="2px"
          align="center"
          borderLeft={`solid 3px ${colors.accentPositive}`}
          pl={1}
        >
          <Text>Total</Text>
        </Flex>
        <Flex fontSize="16px" fontWeight="bold">
          {formatMoney(item.total)}
        </Flex>
      </Flex>

      {itemsCotacao.length ? (
        <>
          <Flex mb={4} w="100%">
            <Flex
              flex={4}
              h="20px"
              w="2px"
              align="center"
              borderLeft={`solid 3px ${colors.accentPositive}`}
              pl={1}
            >
              <Text fontSize="11px" color={colors.accentPositive}>
                Itens aprovados
              </Text>
            </Flex>
            <Flex
              fontSize="13px"
              fontWeight="bold"
              color={colors.accentPositive}
            >
              {formatMoney(totalAprovado ?? 0)}
            </Flex>
          </Flex>

          <Flex mb={4} w="100%">
            <Flex
              flex={4}
              h="20px"
              w="2px"
              align="center"
              borderLeft={`solid 3px ${colors.accentNegative}`}
              pl={1}
            >
              <Text fontSize="11px" color={colors.accentNegative} w="50%">
                Itens não aprovados
              </Text>
            </Flex>
            <Flex
              fontSize="13px"
              fontWeight="bold"
              color={colors.accentNegative}
            >
              {formatMoney(totalNaoAprovado ?? 0)}
            </Flex>
          </Flex>
        </>
      ) : null}
    </Flex>
  );
}
